import {QuestionList} from '../../types';
import Img from '../../img/scenes/page_01.jpg'

export const Day2: QuestionList = [{
    id: 101,
    img: Img,
    question: `<p>До вас прямує пасажир з пакетом з ресторану швидкого харчування. Він сідає позаду й нетерпляче дістає бургер.</p>
<p>У вас двоє дітей, тож до крихт не звикати, але лише вчора ви попилососили машину.</p>
<p>Ваші дії?</p>`,
    answers: [
        {
            id: 1,
            text: 'Прошу прибрати їжу, не рушаючи',
            next: 201,
        },
        {
            id: 2,
            text: 'Рушаю, але прошу не їсти в салоні',
            next: 102,
        },
    ],
},
    {
        id: 201,
        question: `Пасажир емоційно пояснює, що має лише 15 хвилин між справами, аби поїсти. Благає вас їхати, бо він спізнюється.`,
        answers: [
            {
                id: 1,
                text: 'Нічого не відповідаю і рушаю',
                next: 202,
            },
            {
                id: 2,
                text: 'Наполягаю сховати їжу',
                next: 203,
            },
            {
                id: 3,
                text: 'Прошу не смітити і бути охайним',
                next: 204,
            },
        ],
    },
    {
        id: 202,
        question: `<p>Пасажир це сприймає як згоду. Ви їдете під акомпанемент швидкої трапези, але нічого не вдієш.</p>
<p>Ви приїхали. Щасливий ситий пасажир дякує вам за розуміння.</p>`,
        answers: [
            {
                id: 1,
                text: 'Далі',
                next: 205,
            },
        ],
    },
    {
        id: 203,
        question: `<p>Пасажир присягається не залишити ні крихти, та ви невблаганні. Тоді він засмучено ховає їжу.</p>
<p>Ви рушаєте. Пояснити пасажиру, чому для вас така важлива чистота салону?</p>`,
        answers: [
            {
                id: 1,
                text: 'Так',
                next: 206,
            },
            {
                id: 2,
                text: 'Ні',
                next: 206,
            },
        ],
    },
    {
        id: 204,
        question: `<p>Пасажир дякує. Ви їдете під акомпанемент швидкої, але охайної трапези.</p>
<p>Ви приїхали. Щасливий ситий пасажир дякує за розуміня.</p>`,
        answers: [
            {
                id: 1,
                text: 'Далі',
                next: 207,
            },
        ],
    },
    {
        id: 205,
        question: `Ви отримуєте 5 зірок від пасажира і 15 грн чайових.
Але на задньому сидінні залишаються крихти, тож витрачаєте ще 10 хвилин на прибирання.`,
        rate: 5,
        answers: [
            {
                id: 1,
                text: 'Працюю далі',
                next: 0,
            },
        ],
    },
    {
        id: 206,
        question: `Пасажир ображено замовкає. Ви отримуєте 4 зірки від голодного пасажира.`,
        rate: 4,
        answers: [
            {
                id: 1,
                text: 'Працюю далі',
                next: 0,
            },
        ],
    },
    {
        id: 207,
        question: `Ви отримуєте 5 зірок від пасажира і 10 грн чайових.
Але крихти на задньому сидінні ви все одно отримуєте, тож витрачаєте ще 10 хвилин на прибирання.`,
        rate: 5,
        answers: [
            {
                id: 1,
                text: 'Працюю далі',
                next: 0,
            },
        ],
    },
    {
        id: 102,
        question: `<p>Пасажир пояснює, що має лише 15 хвилин між справами, аби поїсти. Він присягається не залишити жодної крихти.</p>
<p>Ваші дії?</p>`,
        answers: [
            {
                id: 1,
                text: 'Нічого не відповідаю – пасажир це сприймає як згоду',
                next: 103,
            },
            {
                id: 2,
                text: 'Все одно прошу не їсти в салоні',
                next: 208,
            },
        ],
    },
    {
        id: 103,
        question: `<p>Ви їдете під акомпанемент трапези, але запізно виказувати невдоволення. </p>
<p>Ви прибули. Щасливий ситий пасажир дякує вам за розуміння.</p>`,
        answers: [
            {
                id: 1,
                text: 'Далі',
                next: 104,
            },
        ],
    },
    {
        id: 104,
        question: `<p>Ви отримуєте 5 зірок від пасажира і 20 грн чайових.</p>
<p>Але крихти на задньому сидінні ви також отримуєте, тож витрачаєте ще 10 хвилин на прибирання.</p>`,
        rate: 5,
        answers: [
            {
                id: 1,
                text: 'Працюю далі',
                next: 0,
            },
        ],
    },
    {
        id: 208,
        question: `Пасажир ображено не говорить ні слова до кінця поїздки. Ви отримуєте 3 зірки.`,
        rate: 3,
        answers: [
            {
                id: 1,
                text: 'Працюю далі',
                next: 0,
            },
        ],
    },
];
